import { render } from "./ContactList.vue?vue&type=template&id=de6d8ea4&scoped=true"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"

import "./ContactList.vue?vue&type=style&index=0&id=de6d8ea4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-de6d8ea4"

export default script